import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { Dispatch } from 'redux';
import { openSellersInfoModal } from 'shared/actions/sellersInfoModal';

import { trackNewbuildingInfoLabelClick } from './tracking';
import { EGalleryLabelColor, IGalleryLabel } from '../../../../types/gallery-label';

interface IGetNewbuildingMediaLabelsParams {
  id: number;
  dispatch: Dispatch;
}

export const getNewbuildingMediaLabels = ({ id, dispatch }: IGetNewbuildingMediaLabelsParams): IGalleryLabel[] => {
  return [
    {
      color: EGalleryLabelColor.Black,
      label: 'Первичная продажа',
      uiKitIcon: <IconFunctionalInformationCircle16 color="current_color" />,
      onClick: (event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        dispatch(openSellersInfoModal());
        trackNewbuildingInfoLabelClick(id);
      },
    },
  ];
};
